<template>
  <div :class="componentClassName">
    <div id="userStatus" class="m-sf-current-user-status__body" @click="handleClick">
      <div class="m-sf-current-user-status__label">{{ businessHourText }}</div>
      <div class="m-sf-current-user-status__avatar">
        <a-avatar :active="online" />
        <div :class="indicatorClassName">
          <a-icon :icon="statusIcon" color="white" />
        </div>
      </div>
      <div class="m-sf-current-user-status__user-info">
        <div class="m-sf-current-user-status__user-name">
          {{ currentUserName }}
        </div>
        <div class="m-sf-current-user-status__status">
          {{ statusText }}
        </div>
      </div>
      <div class="m-current-user-status__caret">
        <a-icon :icon="iconShape" :color="iconColor" />
      </div>
    </div>
    <div class="m-sf-current-user-status__option-container">
      <ul class="m-sf-current-user-status__options">
        <li>
          <a-button id="changeStatus" type="text" @click="changeStatus">
            <div :class="switchIndicatorClassName">
              <a-icon :icon="switchStatusIcon" color="white" />
            </div>
            <strong>{{ switchStatusText }}</strong> に変更
          </a-button>
        </li>
        <!--
        <li>
          <a-button id="editProfile" type="text" @click="handleLinkClick('/profilelist')">プロフィールの編集</a-button>
        </li>
        -->
        <li>
          <a-button id="logout" type="text" @click="logout">ログアウト</a-button>
        </li>
        <li class="m-sf-current-user-status__account-id">契約ID：{{ companyId }}</li>
        <li class="m-sf-current-user-status__phone-number">利用番号：{{ localkPhoneNumber }}</li>
      </ul>
    </div>
    <teleport to="body">
      <o-modal
        id="sfCurrentUserStatus_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAvatar from '@/components/atoms/avatar';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { utils } from '@/common/utils.js';

export default {
  name: 'm-sf-current-user-status',
  components: {
    AAvatar,
    AButton,
    AIcon,
  },
  mixins: [customRequest],
  props: {
    online: {
      type: Boolean,
      default: false,
    },
    businessHour: {
      type: Boolean,
      default: true,
    },
    class: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      required: true,
    },
    companyId: {
      type: String,
      required: true,
    },
    editProfileUrl: {
      type: String,
      default: '#',
    },
    logoutUrl: {
      type: String,
      default: '#',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    handleOnlineStatusChange: {
      type: Function,
      default: () => {},
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
  },
  emits: [],
  data() {
    return {
      opened: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      localkPhoneNumber: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'm-sf-current-user-status',
        this.online ? 'online' : '',
        this.businessHour ? 'during-business-hour' : 'out-of-business-hour',
        this.opened ? 'opened' : ''
      );
      return `${baseClassName} ${this.class}`.trim();
    },
    indicatorClassName() {
      return mapModifiers('m-sf-current-user-status__indicator', this.online ? 'active' : 'inactive');
    },
    switchIndicatorClassName() {
      return mapModifiers('m-sf-current-user-status__indicator', this.online ? 'inactive' : 'active');
    },
    statusIcon() {
      return this.online ? 'check' : 'minus';
    },
    switchStatusIcon() {
      return this.online ? 'minus' : 'check';
    },
    statusText() {
      return this.online ? '応答可能' : '応答不可';
    },
    switchStatusText() {
      return this.online ? '応答不可' : '応答可能';
    },
    businessHourText() {
      return this.businessHour ? '営業時間中' : '営業時間外';
    },
    iconShape() {
      return this.opened ? 'caret-up' : 'caret-down';
    },
    iconColor() {
      return this.businessHour ? 'white' : 'black';
    },
    currentUserName() {
      return this.userName.replace('_', ' ');
    },
  },
  watch: {
    businessHour(val, oldVal) {
      this.businessHourStatus = val;
    },
  },
  mounted() {
    if (utils.chkTrialCompanyID(this.companyId)) {
      this.localkPhoneNumber = messageContent.statusPhoneNumberTrial();
    } else {
      this.localkPhoneNumber = this.phoneNumber;
    }
  },
  methods: {
    handleClick() {
      this.opened = !this.opened;
    },
    handleLinkClick: function (route) {
      this.$router.push(route);
    },
    changeStatus() {
      const onlineStatus = !this.online;
      this.opened = !this.opened;
      this.handleOnlineStatusChange(onlineStatus);
    },
    logout: function () {
      const self = this;
      this.postRequest('/login/logout').then(data => {
        if (data.status === 'success') {
          self.handleLogout();
          window.location.href = '/sf-login';
        } else if (data.status === 'failed') {
          self.showErrorModal(messageContent.requireTry('ログアウト'));
        }
      });
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
  },
};
</script>
